<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <StatusBar :params="this.$route.query.params"></StatusBar>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 查詢列 -->
    <SearchBar
      :show="showSearchBar"
      @showSearchBar="showSearchBar = !showSearchBar"
      @search="(currentPage = 1), getInterviewResult()"
    >
      <template v-slot:searchItem>
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="關鍵字（姓名、Email、聯絡電話）"
          v-model.trim="searchCondition.Keyword"
        />
        <el-date-picker
          class="w-100 item-bottom"
          type="daterange"
          clearable
          :picker-options="{
            disabledDate: $common.disabledDateAfterToday,
          }"
          range-separator="-"
          start-placeholder="面談日期(起)"
          end-placeholder="面談日期(迄)"
          v-model="searchCondition.InterviewDateRange"
        />
        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="單位面試主管"
          v-model="searchCondition.InterviewSupervisor"
        >
          <el-option
            v-for="supervisor in supervisorOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>

        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="HR 面試人員"
          v-model="searchCondition.InterviewHR"
        >
          <el-option
            v-for="supervisor in supervisorOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>
        <!-- 應聘者狀態 -->
        <el-select
          class="w-100 item-bottom"
          multiple
          clearable
          placeholder="應聘者狀態"
          v-model="searchCondition.Status"
        >
          <el-option label="錄取" value="錄取" />
          <el-option label="考慮中" value="考慮中" />
          <el-option label="複試" value="複試" />
          <el-option label="不錄取" value="不錄取" />
        </el-select>
        <!-- 是否已發送感謝函 -->
        <el-select
          class="w-100 item-bottom"
          clearable
          placeholder="是否已發送感謝函"
          v-model="searchCondition.IsSendThanksMail"
        >
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </template>
    </SearchBar>

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :totalPerson="totalPerson"
      :selectedCardList="choosePersonList"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button>
        <button type="button" class="action-btn" @click="sendThanksMail()">
          <eva-icon name="email-outline" fill="#FFF" />
          <span>批次發送感謝函</span>
        </button>
      </template>
    </ActionBar>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard
          ref="personCard"
          :showCheckbox="true"
          :person="person"
          @updatePersonList="updatePersonList"
        >
          <template v-slot:note="{ props }">
            <button type="button" @click="clickResumeNote(props)">
              <eva-icon name="color-picker-outline" fill="#000" />
            </button>
          </template>

          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>面談日期</th>
                <td>{{ $common.dateFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
              <tr>
                <th>是否發過感謝函</th>
                <td>
                  <span>{{
                    props.SendThankNoticeTime === null ? "否" : "是"
                  }}</span>
                </td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button
              v-if="
                props.ApprovalResult === '錄取' ||
                props.ApprovalResult === '考慮中'
              "
              type="button"
              @click="createAppointmentForm(props)"
            >
              起任用單
            </button>
            <template v-if="props.ApprovalResult === '不錄取'">
              <button
                v-if="props.SendThankNoticeTime === null"
                type="button"
                @click="sendThanksMail(props)"
              >
                發感謝函
              </button>
              <el-tooltip
                v-else
                class="item"
                effect="light"
                content="已發過感謝函"
                placement="right"
              >
                <button type="button" @click="sendThanksMail(props)">
                  發感謝函
                </button>
              </el-tooltip>
            </template>
            <button type="button" @click="getApproveInterview(props)">
              面談評估
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 履歷 Note -->
    <ResumeNoteModal :personData="personData" />

    <!-- 感謝函 Modal-->
    <ThanksMailModal
      :personData="personData"
      @clearSelectCard="clearSelectCard"
      @getLatestSearchResult="getInterviewResult"
    />

    <!-- 面談評估 Modal -->
    <EvaluateInterviewModal
      :Source="'InterviewResult'"
      :AdmitOptions="admitOptions"
      :IdlRejectOptions="idlRejectOptions"
      :DlRejectOptions="dlRejectOptions"
      :Person="personData"
      @saveApproveInterview="saveApproveInterview"
    />

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                履歷
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 1">
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF" />
                面談紀錄
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord :MatchId="MatchId"></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 招募狀態列表
import StatusBar from "@/components/back/OpeningManage/StatusBar";
// 查詢列
import SearchBar from "@/components/back/ToolBar/SearchBar";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 履歷 Note
import ResumeNoteModal from "@/components/back/Modal/ResumeNote";
// 感謝函
import ThanksMailModal from "@/components/back/Modal/ThanksMail";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 面談評估
import EvaluateInterviewModal from "@/components/back/Modal/EvaluateInterview";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";

export default {
  name: "InterviewResult",

  props: {
    did: { // 需求單號
      type: String,
    },
    pos: { // 職缺名稱
      type: String,
    },
  },

  components: {
    Logo,
    StatusBar,
    SearchBar,
    CardStyle,
    ActionBar,
    PersonCard,
    ResumeNoteModal,
    ThanksMailModal,
    IdlResume,
    DlResume,
    InterviewRecord,
    EvaluateInterviewModal,
    ProgressRecordModal,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 人員列表
      personList: [],
      // 選取之人員列表
      choosePersonList: [],

      // 人員資料
      personData: {},

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類
      showInterviewRecord: false, // 面談紀錄

      // 查詢條件
      searchCondition: {},
      supervisorOptions: [],

      // 面談評估 Modal
      admitOptions: [], // 錄取[備註]選項
      idlRejectOptions: [], // idl-不錄取[原因]選項
      dlRejectOptions: [], // dl-不錄取[原因]選項

      // 功能 bar
      showSearchBar: false, // 放大鏡
      showActionBar: false, // 圖卡勾選後-功能列

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,
    };
  },

  methods: {
    // 取得 面談結果列表
    getInterviewResult() {
      let candidateStatus;
      candidateStatus =
        this.searchCondition.Status &&
        Object.keys(this.searchCondition.Status).length > 0
          ? String(this.searchCondition.Status)
          : null;

      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.jobManagement
        .getInterviewResultPaging(
          {
            Keyword: this.searchCondition.Keyword,
            IsSendThanksMail: this.searchCondition.IsSendThanksMail,
            interviewDateStart: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[0]
                )
              : null,
            interviewDateEnd: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[1]
                )
              : null,
            ApprovalResult: candidateStatus,
            Page: this.currentPage,
            PerPage: 9,
          },
          this.did
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              this.totalPerson = response.data.Quantity;
              this.personList = response.data.Datas;
              this.$store.commit("ScrollTop", false);
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getInterviewResult();
    },

    // 取得面談評估
    getApproveInterview(props) {
      this.personData = props;
      this.$store.commit("OpenEvaluateInterviewModal", true);
    },

    // 完成面談評估
    saveApproveInterview(params) {
      this.$store.commit("OpenEvaluateInterviewModal", false);
      this.updateLoading(true);

      this.$api.approveInterview
        .putApproveInterview(params)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2500,
            });
            this.currentPage = 1;
            this.getInterviewResult();
          }
          this.updateLoading(false);
        });
    },

    // 履歷 Note
    clickResumeNote(person) {
      this.personData = person;
      this.$store.dispatch("getResumeSummary", person.MatchId);
      this.$store.commit("OpenResumeNoteModal", true);
    },

    // 感謝函
    sendThanksMail(person) {
      if (this.choosePersonList.length > 0) {
        const result = this.choosePersonList
          .map((item) => item.ApprovalResult.indexOf("不錄取"))
          .includes(-1);
        if (result) {
          this.$notify({
            title: "失敗",
            message: "選取之履歷為不錄取，才能寄送感謝函。",
            type: "error",
            duration: 3500,
          });
          return;
        } else {
          this.personData.MatchId = this.choosePersonList.map(
            (person) => person.MatchId
          );
          this.personData.Name = null;
        }
      } else {
        this.personData.MatchId = [person.MatchId];
        this.personData.Name = person.Name;
      }
      
      this.personData.Position = this.pos;

      this.$store.commit("OpenThanksMailModal", true);
    },

    // 建立任用單
    createAppointmentForm(item) {
      this.$router.push({
        path: `/manager/form/evaluation/create/${item.MatchId}`,
      });
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      const interviewResult = ["錄取", "考慮中", "複試", "不錄取"];
      this.showInterviewRecord = interviewResult.includes(person.InterviewResult);
      this.isShowDetail = true;
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 即時更新選取人員之列表
    updatePersonList(choosePerson) {
      let repeatIndex = this.choosePersonList.findIndex(
        (element) => element.MatchId === choosePerson[0].MatchId
      );
      if (repeatIndex === -1) {
        this.choosePersonList.push(choosePerson[0]);
      } else {
        this.choosePersonList.splice(repeatIndex, 1);
      }
    },

    // 全選人員
    selectAllCards() {
      this.personList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.choosePersonList = this.personList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除所選取人員
    clearSelectCard() {
      this.personList.forEach((item) => {
        item.isChecked = false;
      });
      this.choosePersonList = [];
    },

    async getData() {
      // 取得錄取的[備註]下拉選單
      const admit = await this.$api.recruitment.getInterviewBasicCondition();
      // 取得idl不錄取的[原因]下拉選單
      const idl = await this.$api.recruitment.getInterviewNotAdmitReason({
        ResumeType: "IDL",
        IsNotAdmitReason: true,
      });
      // 取得dl不錄取的[原因]下拉選單
      const dl = await this.$api.recruitment.getInterviewNotAdmitReason({
        ResumeType: "DL",
        IsNotAdmitReason: true,
      });
      // 取得 主管列表
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();
      this.admitOptions = admit.data;
      this.idlRejectOptions = idl.data;
      this.dlRejectOptions = dl.data;
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
        };
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // 選取人員列表
    choosePersonList: function (e) {
      if (e.length > 0) {
        this.showActionBar = true;
        this.showSearchBar = false;
      } else {
        this.showActionBar = false;
      }
    },
    // 檢視資訊
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.getData();
    this.getInterviewResult();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input {
  display: block;
}

/deep/ .el-select {
  display: block;
}
</style>
